import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

export default function UserHeader() {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  const toggleSidebar = () => {
    if (window.innerWidth <= 768) {
      document.body.classList.toggle("sidebar-open");
    } else {
      document.body.classList.toggle("sidebar-collapsed");
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="uh-header">
      <div className="uh-left">
        <button className="uh-toggle" onClick={toggleSidebar}>
          <i className="bi bi-list"></i>
        </button>

        <h4 className="uh-title">Dashboard</h4>
      </div>

      <div className="uh-right" ref={dropdownRef}>
        <div className="uh-user" onClick={() => setOpen(!open)}>
          <i className="bi bi-person-circle"></i>

          <span>Admin</span>

          <i className="bi bi-chevron-down"></i>
        </div>

        {open && (
          <div className="uh-dropdown">
            <Link to="/user/profile">
              <i className="bi bi-person"></i>
              Profile
            </Link>

            <Link to="/user/change-password">
              <i className="bi bi-lock"></i>
              Change Password
            </Link>

            <Link to="/user/logout">
              <i className="bi bi-box-arrow-right"></i>
              Logout
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
